import React from "react";
import { required, SaveButton, SimpleForm, TextInput, useNotify } from "react-admin";

import useAuthMutations from "../../store/mutations/useAuthMutations";

type CodeFormProps = {
  email: string;
};

const CodeFormForm: React.FC<CodeFormProps> = ({ email }) => {
  const notify = useNotify();
  const { redeemInvitationCode } = useAuthMutations(notify);

  const validateCode = [required()];

  const handleSubmit = (fromData: any) => {
    const data = fromData as { email: string; code: string };
    redeemInvitationCode(data);
  };

  return (
    <SimpleForm
      className="c-form c-form_code"
      onSubmit={handleSubmit}
      id="c-form_code"
      toolbar={<SaveButton icon={<></>} className="c-form__submit-btn" label="Continue" />}
      mode="onBlur"
      reValidateMode="onBlur"
    >
      <TextInput
        className="c-form__input c-form__input_text"
        label="Email"
        source="email"
        value={`${email}`}
        defaultValue={`${email}`}
        disabled
        style={{ display: "none" }}
      />
      <TextInput className="c-form__input c-form__input_text" label="Code" source="code" validate={validateCode} />
    </SimpleForm>
  );
};

export default CodeFormForm;
